import { Icon } from '@datacamp/le-shared-components';
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Droppable from '../Droppable';
import { jsx as ___EmotionJSX } from "@emotion/react";
const I18N_PLACEHOLDER = '__placeholder__';
export const Indent = () => {
  const {
    t
  } = useTranslation();
  return ___EmotionJSX(React.Fragment, null, "\xA0", ___EmotionJSX(Trans, {
    components: {
      arrows: ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Icon, {
        color: "grey",
        name: "arrow_left",
        size: 10,
        style: {
          opacity: 0.6
        }
      }), ___EmotionJSX(Icon, {
        color: "grey",
        name: "arrow_right",
        size: 10,
        style: {
          margin: '0px 4px 0px 0px',
          opacity: 0.6
        }
      })),
      highlight: ___EmotionJSX("span", {
        style: {
          background: 'rgba(61, 66, 81, 0.1)',
          borderRadius: 4,
          color: '#4D5356',
          padding: '4px 6px 5px 4px'
        }
      }, I18N_PLACEHOLDER)
    },
    i18nKey: 'OrderList.indent',
    t: t
  }));
};
const OrderList = _ref => {
  let {
    groupedItems,
    setItemOffset,
    target: {
      id,
      language: languageOfTarget,
      maxOffset
    }
  } = _ref;
  const {
    t
  } = useTranslation();
  return ___EmotionJSX("div", {
    className: "dc-u-ifx dc-u-w-100pc dc-u-h-100pc dc-u-ph-12 dc-u-bgc-grey-100 dc-u-of-auto",
    "data-cy": "order-exercise-list-container"
  }, ___EmotionJSX(Droppable, {
    droppableId: id,
    extraClass: "dc-u-fxi-f-1 dc-u-m-auto dc-u-fx-jcc",
    items: groupedItems[id],
    key: id,
    languageOfTarget: languageOfTarget,
    maxOffset: maxOffset,
    overrideDropStyle: {
      overflow: 'hidden'
    },
    setItemOffset: setItemOffset,
    title: ___EmotionJSX("p", {
      className: "dc-u-mb-0 dc-u-mt-12 dc-u-color-navy-text dc-u-ta-center"
    }, t('OrderList.text'), maxOffset > 0 && ___EmotionJSX(Indent, null))
  }));
};
export default OrderList;